import React, { PropsWithChildren, useState } from 'react';
import { Col, Form, Nav, Row, Tab } from 'react-bootstrap';
import { VerticalTabPane } from './VerticalTabPane';

interface VerticalTabsProps {
  ActiveTab: string;
  ChangeTab(arg: string): void;
  TabContainerId: string;
  Tabs: string[];
}

const VerticalTabs = (props: PropsWithChildren<VerticalTabsProps>) => {
  const { ActiveTab, ChangeTab, TabContainerId, Tabs, children } = props;
  const [activeNavLink, setActiveNavLink] = useState<string>(ActiveTab);

  const handleLinkClick = (tab: string) => {
    ChangeTab(tab);
    setActiveNavLink(tab);
  };

  const handleSelectChange = (Event: React.ChangeEvent<HTMLSelectElement>) => {
    handleLinkClick(Event.target.value);
  };

  return (
    <Tab.Container id={TabContainerId}>
      <Row className="gx-lg-48">
        <Col md={3}>
          <Form.Select
            className="vertical-tabs-menu d-block d-md-none mb-32"
            defaultValue={ActiveTab}
            onChange={e => handleSelectChange(e)}
          >
            {Tabs.map((tab, index) => (
              <option key={tab} value={tab}>
                {tab}
              </option>
            ))}
          </Form.Select>
          <Nav variant="pills" className="flex-column d-none d-md-block">
            {Tabs.map((tab, index) => (
              <Nav.Item key={encodeURI(tab)}>
                <Nav.Link
                  active={ActiveTab === tab}
                  onClick={() => handleLinkClick(tab)}
                >
                  {tab}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Col>
        <Col md={9}>
          <Tab.Content>{children}</Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default VerticalTabs;
export { VerticalTabs };
export type { VerticalTabsProps };
